import React, { FC, lazy } from "react";

// UI components
import { Box } from "../Box/Box";
import { Icon } from "../Icon/Icon";

import useMediaQuery from "../../hooks/useMediaQuery";

export interface CornerProps {
  icon?: string;
  background?: string;
  color?: string;
}

const ICONS = {
  star: lazy(() =>
    import("../Icons/Star").then(({ Star }) => ({ default: Star }))
  ),
  percent: lazy(() =>
    import("../Icons/Percent").then(({ Percent }) => ({ default: Percent }))
  ),
};

export const Corner: FC<CornerProps> = ({
  icon = "star",
  background = "green.500",
  color = "white",
}) => {
  const { isDesktop } = useMediaQuery();
  const IconSvg = ICONS[icon];
  return (
    <Box
      position="absolute"
      top="-100px"
      right="-100px"
      height="100px"
      width="100px"
    >
      <Icon
        as={IconSvg}
        color={color}
        position="absolute"
        top={["calc(100px + .375rem)", "calc(100px + .425rem)"]}
        right={["calc(100px + .375rem)", "calc(100px + .425rem)"]}
        zIndex="2"
        size={isDesktop ? "lg" : undefined}
      />
      <Box
        background={background}
        position="absolute"
        top="0"
        right="0"
        transform="rotate(-45deg)"
        height={["145px", "145px", "150px"]}
        width={["145px", "145px", "150px"]}
      />
    </Box>
  );
};
